import { Input, Label, Textarea } from "../../../../../../components"
import { Controller, useFormContext } from "react-hook-form"
import type { ListDocumenType } from "../../types"

type FormType = { action?: string }
export function FormSection({ action }: FormType) {
  const { control } = useFormContext<ListDocumenType>()
  const isDisable = action === "DETAIL" || action === "DELETE"

  return (
    <table className="table">
      <tbody>
        <Controller
          control={control}
          name="mr_document_code"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="CODE" error={Boolean(fieldState.error)} /></td>
              <td>
                <Input {...field} 
                  placeholder="Input document type code" 
                  value={field.value ?? ""} 
                  error={fieldState.error?.message} 
                  disabled={isDisable} 
                />
              </td>
            </tr>
          }
        />

        <Controller
          control={control}
          name="mr_document_name"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="DOCUMENT TYPE" error={Boolean(fieldState.error)} /></td>
              <td>
                <Input 
                  {...field} 
                  placeholder="Input document type name" 
                  value={field.value ?? ""} 
                  error={fieldState.error?.message} 
                  disabled={isDisable} 
                />
              </td>
            </tr>
          }
        />

        <Controller
          control={control}
          name="description"
          render={({ field, fieldState }) => 
            <tr>
              <td><Label text="DESCRIPTION" /></td>
              <td>
                <Textarea 
                  {...field} 
                  placeholder="Input Description" 
                  value={field.value ?? ""}
                  disabled={isDisable} 
                  error={fieldState.error?.message}
                />
              </td>
            </tr>
          }
        />
      </tbody>
    </table>
  )
}